this.level && this.unknownElement && [
    <div class="unknown-element">
        <div class="symbol">{this.symbol}</div>
        <span class="title">{this.title}</span>
    </div>,
];